import { useCallback, useEffect, useState } from 'react';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { WellInfoForSite } from 'types/wellGuardian';

export const useFetchWgWells = (asset: string, site: string, countrySelect: string) => {
  const [wellsForSiteLoading, setWellsForSiteLoading] = useState<boolean>(false);
  const [wellsForSite, setWellsForSite] = useState<WellInfoForSite[]>([]);

  const fetchWellsForSite = useCallback(async () => {
    if (!countrySelect) return;

    setWellsForSiteLoading(true);

    try {
      const wellsResonse = await wellGuardianApiClient.getWellsInfoForSite(
        asset,
        site,
        countrySelect,
      );
      const wellsForSelectedSite = wellsResonse.map(item => ({
        wellName: item.wellName,
        wellViewId: item.wellViewId,
      }));
      setWellsForSite(wellsForSelectedSite);
    } catch {
      setWellsForSite([]);
    } finally {
      setWellsForSiteLoading(false);
    }
  }, [asset, site, countrySelect]);

  useEffect(() => {
    fetchWellsForSite();
  }, [fetchWellsForSite]);

  return {
    wellsForSiteLoading,
    wellsForSite,
    setWellsForSite,
    setWellsForSiteLoading,
  };
};
